import { useQueryClient } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { candidaciesMinimalQueryKey } from "@/hooks/queries/useGetCandidaciesMinimal";
import { MinimalCandidacy, MyCandidacyResponse } from "@/types";

// Removes a candidacy from both candidacies-minimal (pipeline) and
// my-candidacies (My Aviary) caches without refetching.
export const useRemoveCandidacyFromAllLists = () => {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();
  const queryClient = useQueryClient();

  return ({ candidacyId }: { candidacyId: string }) => {
    queryClient.setQueriesData(
      { queryKey: candidaciesMinimalQueryKey(currentCompanyId, currentJobId) },
      (cachedData?: MinimalCandidacy[]) => {
        if (!cachedData) return cachedData;
        return cachedData.filter(
          (minimalCandidacy: MinimalCandidacy) =>
            minimalCandidacy.id !== candidacyId,
        );
      },
    );

    queryClient.setQueriesData(
      { queryKey: ["my-candidacies"] },
      (
        cachedData?: MyCandidacyResponse[],
      ): MyCandidacyResponse[] | undefined => {
        if (!cachedData) return cachedData;
        return cachedData.filter((row) => row.candidacyId !== candidacyId);
      },
    );
  };
};
